import { render } from "./index.vue?vue&type=template&id=5ef489c4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5ef489c4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\wy2204\\bamboo\\argus-energy\\argus-energy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef489c4"]])

export default __exports__